module.exports = __webpack_public_path__ + "static/media/48.699e6df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/48.jpg
// module id = 417
// module chunks = 0